import config from "@/config";
import axios from "axios";

axios.defaults.timeout = 30000;

export default {
  async bind(data) {
    const headers = {
      Authorization: `Bearer nextcapliffapi 6ckq6l3fz6yhy2ma6bytjc`,
    };
    let url = config.COMMU + "/nextcapital/bind";
    try {
      let resData = await axios.post(url, data, { headers });
      if (resData && resData.data) {
        resData = resData.data;
        return resData;
      } else {
        console.log(resData.data);
        return null;
      }
    } catch (error) {
      console.error(error.data);
      return null;
    }
  },
  async regisedSendOtp(data) {
    const headers = {
      Authorization: `Bearer nextcapliffapi 6ckq6l3fz6yhy2ma6bytjc`,
    };
    let url = config.COMMU + "/nextcapital/update/regised/sendotp";
    try {
      let resData = await axios.post(url, data, { headers });
      if (resData && resData.data) {
        resData = resData.data;
        return resData;
      } else {
        console.log(resData.data);
        return null;
      }
    } catch (error) {
      console.error(error.data);
      return null;
    }
  },
  async SendOtpWithAuth(data) {
    const headers = {
      Authorization: `Bearer nextcapliffapi 6ckq6l3fz6yhy2ma6bytjc`,
    };
    let url = config.COMMU + "/nextcapital/auth/sendotp";
    try {
      let resData = await axios.post(url, data, { headers });
      if (resData && resData.data) {
        resData = resData.data;
        return resData;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  },
  async checkOtp(data) {
    const headers = {
      Authorization: `Bearer nextcapliffapi 6ckq6l3fz6yhy2ma6bytjc`,
    };
    let url = config.COMMU + "/nextcapital/update/checkOtp";
    try {
      let resData = await axios.post(url, data, { headers });
      if (resData && resData.data) {
        resData = resData.data;
        return resData;
      } else {
        console.log(resData.data);
        return resData;
      }
    } catch (error) {
      console.error(error.data);
      return null;
    }
  },
  async unbind(data) {
    const headers = {
      Authorization: `Bearer nextcapliffapi 6ckq6l3fz6yhy2ma6bytjc`,
    };
    let url = config.COMMU + "/nextcapital/unbind";
    try {
      let resData = await axios.post(url, data, { headers });
      if (resData && resData.data) {
        resData = resData.data;
        return resData;
      } else {
        console.log(resData.data);
        return null;
      }
    } catch (error) {
      console.error(error.data);
      return null;
    }
  },
  async regis(data) {
    const headers = {
      Authorization: `Bearer nextcapliffapi 6ckq6l3fz6yhy2ma6bytjc`,
    };
    let url = config.COMMU + "/nextcapital/register";
    try {
      let resData = await axios.post(url, data, { headers });
      if (resData && resData.data) {
        resData = resData.data;
        return resData;
      } else {
        console.log(resData.data);
        return null;
      }
    } catch (error) {
      console.error(error.data);
      return null;
    }
  },
  async getUser(userid) {
    const headers = {
      Authorization: `Bearer nextcapliffapi 6ckq6l3fz6yhy2ma6bytjc`,
    };
    let url = config.COMMU + `/nextcapital/userinfo/${userid}?pageid=${config.pageid}`;
    try {
      let resData = await axios.get(url, { headers });
      if (resData && resData.data) {
        resData = resData.data;
        return resData;
      } else {
        console.log(resData.data);
        return null;
      }
    } catch (error) {
      console.error(error.data);
      return null;
    }
  },
  async getaddress(body) {
    const headers = {
      Authorization: `Bearer nextcapliffapi 6ckq6l3fz6yhy2ma6bytjc`,
    };
    let url = config.COMMU + `/nextcapital/regised/getaddress`;
    try {
      let resData = await axios.post(url, body, { headers });
      if (resData && resData.data) {
        resData = resData.data.data;
        return resData;
      } else {
        console.log(resData.data);
        return null;
      }
    } catch (error) {
      console.error(error.data);
      return null;
    }
  },
  async getaddressNoRegis(body) {
    const headers = {
      Authorization: `Bearer nextcapliffapi 6ckq6l3fz6yhy2ma6bytjc`,
    };
    let url = config.COMMU + `/nextcapital/getaddress`;
    try {
      let resData = await axios.post(url, body, { headers });
      if (resData && resData.data) {
        resData = resData.data.data;
        return resData;
      } else {
        console.log(resData.data);
        return null;
      }
    } catch (error) {
      console.error(error.data);
      return null;
    }
  },
  async regisedUpdateAddress(body) {
    const headers = {
      Authorization: `Bearer nextcapliffapi 6ckq6l3fz6yhy2ma6bytjc`,
    };
    let url = config.COMMU + `/nextcapital/update/regised/address`;
    try {
      let resData = await axios.post(url, body, { headers });
      if (resData && resData.data) {
        resData = resData.data.data;
        return resData;
      } else {
        console.log(resData.data);
        return null;
      }
    } catch (error) {
      console.error(error.data);
      return null;
    }
  },
  async getContact(data) {
    const headers = {
      Authorization: `Bearer nextcapliffapi 6ckq6l3fz6yhy2ma6bytjc`,
    };
    let url = config.COMMU + "/nextcapital/getContact";
    try {
      let resData = await axios.post(url, data, { headers });
      if (resData && resData.data) {
        resData = resData.data;
        return resData;
      } else {
        console.log(resData.data);
        return null;
      }
    } catch (error) {
      console.error(error.data);
      return null;
    }
  },
  async setJsonVar(data) {
    const headers = {
      Authorization: `Bearer nextcapliffapi 6ckq6l3fz6yhy2ma6bytjc`,
    };
    let url = config.COMMU + "/setJsonVar";
    try {
      let resData = await axios.post(url, data, { headers });
      if (resData && resData.data && resData.data.responsecode == 200) {
        return 200;
      } else {
        console.log(resData.data);
        return null;
      }
    } catch (error) {
      console.error(error.data);
      return null;
    }
  },
  async genBarCode(data) {
    const headers = {
      Authorization: `Bearer nextcapliffapi 6ckq6l3fz6yhy2ma6bytjc`,
    };
    let url = config.COMMU + "/nextcapital/genBarCode";
    try {
      let resData = await axios.post(url, data, { headers });
      if (resData && resData.data && resData.data.responsecode == 200) {
        return resData.data.data;
      } else {
        console.log(resData.data);
        return null;
      }
    } catch (error) {
      console.error(error.data);
      return null;
    }
  },
  async getContactNoRegised(data) {
    const headers = {
      Authorization: `Bearer nextcapliffapi 6ckq6l3fz6yhy2ma6bytjc`,
    };
    let url = config.COMMU + "/nextcapital/getContactNoRegised";
    try {
      let resData = await axios.post(url, data, { headers });
      if (resData && resData.data) {
        resData = resData.data;
        return resData;
      } else {
        console.log(resData.data);
        return null;
      }
    } catch (error) {
      console.error(error.data);
      return null;
    }
  },
  async UpdatePhone(data) {
    const headers = {
      Authorization: `Bearer nextcapliffapi 6ckq6l3fz6yhy2ma6bytjc`,
    };
    let url = config.COMMU + "/nextcapital/phone";
    try {
      let response = await axios.put(url, data, { headers });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      return null;
    }
  },
  async validataCustomer(data) {
    const headers = {
      Authorization: `Bearer nextcapliffapi 6ckq6l3fz6yhy2ma6bytjc`,
    };
    let url = config.COMMU + "/nextcapital/customer/validation";
    try {
      let response = await axios.post(url, data, { headers });
      if (response && response.data && response.data.responsecode == "200" && response.data.status) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return null;
    }
  },
  async createTicket(data) {
    const headers = {
      Authorization: `Bearer nextcapliffapi 6ckq6l3fz6yhy2ma6bytjc`,
    };
    let url = config.COMMU + "/tickets";
    try {
      let response = await axios.post(url, data, { headers });
      if (response && response.data && response.data.responsecode == "200" && response.data.data[0] && response.data.data[0].pageid) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return null;
    }
  },
};
